import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test-page',
  templateUrl: './test-page.component.html',
  styleUrls: ['./test-page.component.scss']
})
export class TestPageComponent implements OnInit {

  toggleValue = false;
  checkboxValue = false;
  selectValue = '';
  dateValue = new Date();
  sliderValue = 50;
  radioValue = '1';
  inputValue = '';

  constructor() { }

  ngOnInit(): void {
  }

}
